<template>
  <div class="body">
    <el-card class="box_card">
      <div class="card-content">
        <div class="header">
          <div @click="goBackList()" class="flex flex-middle header-l">
            <i class="iconfont icontuichu"></i>
            <span class="bold">返回患者档案</span>
          </div>
        </div>

        <div class="main-content">
          <!-- 检测项目分解 -->
          <div v-for="(val, k1) in orderDetailLibrary" :key="k1">
            <div class="titles flex flex-middle flex-center bold">{{ val.psl_name }}</div>
            <!-- 表格 -->
            <div class="main-table flex flex-middle">
              <div class="item1">检查名称</div>
              <div class="item2">结果</div>
              <div class="item3">参考范围</div>
            </div>
            <div class="patient_box">
              <div
                class="patient_box_item flex flex-middle"
                v-for="(col, k2) in val.order_breakdown_product_summary[0].order_breakdown_product_details"
                :key="k2"
              >
                <div class="item1_content">{{ col.pdl_name }}</div>
                <div class="item2_content">
                  {{ col.papdl_Return_value ? col.papdl_Return_value : '' }}
                  {{ col.pdl_Return_value_unit ? col.pdl_Return_value_unit : '' }}
                  &nbsp;
                  <i
                    v-if="col.orbpd_Result_marker && col.orbpd_Result_marker == 'H'"
                    style="color: #ff0000; font-size: 16px; font-weight: bold"
                    class="el-icon-top"
                  ></i>
                  <i
                    v-if="col.orbpd_Result_marker && col.orbpd_Result_marker == 'L'"
                    style="color: #00bb84; font-size: 16px; font-weight: bold"
                    class="el-icon-bottom"
                  ></i>
                </div>
                <div class="item3_content">{{ col.pdl_Reference_range ? col.pdl_Reference_range : '' }}</div>
              </div>
            </div>
            <div>
              <span style="color: orange; font-weight: bold; font-size: 14px">项目小结:</span>
              <span style="font-size: 14px; color: #666666">
                {{ val.orbps_Interpretation_of_doctors ? val.orbps_Interpretation_of_doctors : '暂无小结' }}
              </span>
            </div>
          </div>
          <!-- 报告解读 -->
          <div v-if="reportInterpretation.length">
            <div class="titles flex flex-middle flex-center bold">报告解读</div>
            <div class="main-table flex flex-middle">
              <div class="item1">名称</div>
              <div class="item2">结果</div>
              <div class="item3">解读建议</div>
            </div>
            <div class="patient_box">
              <div class="patient_box_item flex flex-middle" v-for="(sub, k4) in reportInterpretation" :key="k4">
                <div class="item1_content" style="width: 20%">{{ sub.pdl_name }}</div>
                <div class="item2_content" style="width: 20%">
                  {{ sub.papdl_Return_value ? sub.papdl_Return_value : '' }}
                  <!-- {{ sub.orbps_Interpretation_of_doctors ? sub.orbps_Interpretation_of_doctors : '' }} -->
                </div>
                <div class="item3_content" style="width: 59%; font-size: 14px; font-weight: 400; color: #2d99d7; text-align: left">
                  {{ sub.orbps_Interpretation_of_doctors ? sub.orbps_Interpretation_of_doctors : '' }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'ReportDetail',
  data() {
    return {
      customerId: '',
      reportDetail: {},
      orderDetailLibrary: [], //项目明细详情
      reportInterpretation: [] //报告解读
    };
  },
  async created() {
    this.customerId = this.$route.query.customerId;
    this.reportDetail = await JSON.parse(localStorage.getItem('reportDetail'));
    this.orderDetailLibrary = await JSON.parse(localStorage.getItem('reportDetail')).Order_detail_Library;
    this.handleFun();
  },
  mounted() {},
  methods: {
    //报告解读处理函数（多层遍历）
    handleFun() {
      const that = this;
      that.reportInterpretation = [];
      that.orderDetailLibrary.map((item) => {
        item.order_breakdown_product_summary[0].order_breakdown_product_details.map((val) => {
          if (val.orbps_Interpretation_of_doctors) {
            that.reportInterpretation.push({
              orbps_Interpretation_of_doctors: val.orbps_Interpretation_of_doctors,
              pdl_name: val.pdl_name,
              papdl_Return_value: val.papdl_Return_value,
              orbpd_Result_marker: val.orbpd_Result_marker
            });
          }
        });
      });
      // console.log(this.orderDetailLibrary, '22this.Interpretation');
    },
    //打开患者档案
    goBackList() {
      let that = this;
      that.$router.push({ path: '/patientFiles', query: { customerId: that.customerId } });
    }
  }
};
</script>

<style lang="scss" scoped>
.body {
  height: calc(100vh - 90px);
  // 去除卡片的padding
  ::v-deep .el-card__body {
    padding: 0px !important;
    height: 100%;
  }
  .box_card {
    height: 99%;
    margin-right: 30px;
    box-sizing: border-box;
    border-radius: 30px;
    // border: 2px solid orange;
    .card-content {
      height: 100%;
      display: flex;
      flex-direction: column;
      box-sizing: border-box;
      .header {
        background: #f0feff;
        border-radius: 30px 30px 0px 0px;
        padding: 12px 0 12px 31px;

        .header-l {
          cursor: pointer;
          color: #2d99d7;
          font-size: 20px;
          i {
            font-size: 30px;
            margin-right: 11px;
          }
        }
      }

      .main-content {
        padding: 0 30px;
        flex: 1;
        // border: 2px solid rgb(255, 0, 255);
        overflow-y: auto;

        .titles {
          font-size: 22px;
          color: #2d99d7;
          margin: 14px 0 10px 0;
        }

        .descs {
          font-size: 16px;
          color: #666;
        }

        .main-table {
          margin-top: 10px;
          height: 36px;
          border-radius: 16px 16px 0px 0px;
          background: #31bfc5;
          font-size: 16px;
          font-weight: bold;
          color: #f8f9fe;
          padding-left: 25px;

          .item1 {
            width: 23%;
          }

          .item2 {
            width: 55%;
          }

          .item3 {
            width: 20%;
            text-align: center;
          }
        }
        .patient_box {
          // height: calc(100vh - 300px);
          // max-height: calc(100vh - 300px);
          // border: 1px solid rgb(218, 13, 13);
          // overflow-y: auto;
          box-sizing: border-box;
          border-bottom-left-radius: 16px;
          border-bottom-right-radius: 16px;

          .patient_box_item {
            padding-left: 25px;
            background: #f8f9fe;
            padding: 10px 0;
            border-bottom: 1px solid #dddddd;

            .item1_content {
              width: 23%;
              font-size: 14px;
              font-weight: bold;
              color: #333333;
              padding-left: 10px;
            }

            .item2_content {
              width: 56%;
              font-size: 14px;
              font-weight: 400;
              color: #666666;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              overflow: hidden;
            }

            .item3_content {
              width: 20%;
              min-height: 14px;
              font-size: 16px;
              font-weight: bold;
              color: #f04562;
              text-align: center;
            }
          }
        }
      }
    }
  }
  .itmeBox :hover {
    box-shadow: 0px 0px 10px #effffc;
    // background-color: red;
  }
}
</style>
